<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Form Categories</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content pt-4 pb-1 px-3">

  <ng-container matColumnDef="only_archived">
    <div style="padding: 0 15px !important;">
      <mat-form-field appearance="outline" style="width:100%;" floatLabel="always" class="mb-3">
        <mat-label>Show Active or Archived Categories.</mat-label>
        <mat-select [(ngModel)]="filter_options.only_archived" matTooltip="Filter form categories by archival status." name="only_archived">
          <mat-option value="false">All Active</mat-option>
          <mat-option value="true">Only Archived</mat-option>
        </mat-select>
        <mat-hint>Use this to filter between active and archived form categories.</mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
